module.exports = __webpack_public_path__ + "img/a2.1c820c7c.png";